<template>
  <app-table-view :header="header" :headerSize="'h2'" :items="model.location_history">
    <template slot="default" slot-scope="{ item }">
      <v-layout row wrap>
        <v-flex xs3>
          <span>{{item.region_name}}</span>
        </v-flex>
        <v-flex xs4>
          <span>{{item.metro}}</span>
        </v-flex>
        <v-flex xs5>
          <span>{{item.exact}}</span>
        </v-flex>
      </v-layout>
    </template>
  </app-table-view>
</template>

<script>
import AppTableView from "../../common/table-view";
export default {
  name: "app-resume-location-view",
  components: {AppTableView},
  data() {
    return { header: "Местоположение" };
  },
  props : {
    model : {}
  }
}
</script>
